import { Component, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterService } from '../../../services/filter/filter.service';
import { ProfileService } from '../../../services/profile/profile.service';
import { pageInfo, Constant, PlatFormType, ManageTitle, forumPageAccess } from 'src/app/common/constant/constant';
import { LandingpageService } from '../../../services/landingpage/landingpage.service';
import { ThreadPostService } from '../../../services/thread-post/thread-post.service';
import { AnnouncementService } from '../../../services/announcement/announcement.service';
import { ProductMatrixService } from '../../../services/product-matrix/product-matrix.service';
import * as moment from 'moment';
@Component({
  selector: 'app-followers-following',
  templateUrl: './followers-following.component.html',
  styleUrls: ['./followers-following.component.scss']
})
export class FollowersFollowingComponent implements OnInit {

  @Input() dashboardData: any;
  @Input() apiKey: any;
  @Input() domainId: any;
  @Input() countryId: any;
  @Input() userId: any;
  @Input() type: any;
  @Input() loginUserId: any;
  @Output() updatefollowingResponce: EventEmitter<any> = new EventEmitter();

  public bodyElem;
  public bodyClass:string = "manage-list";  
  public bodyClass1:string = "max-width-930";  
  public title: string = "";
  public manageList:any = [];
  public viewList:any = [];
  public likeList:any = [];
  public pinList:any = [];
  public contributoList:any = [];
  public solvedByList:any = [];
  public listItems = [];
  public selectionList = [];
  public listLength: number = 0;
  public count: number = 0;

  public loading: boolean = true;
  public searchVal: string = '';
  public searchForm: UntypedFormGroup;
  public searchTick: boolean = false;
  public searchClose: boolean = false;
  public submitted: boolean = false;
  public empty: boolean = false;
  public actionFlag: boolean = false;

  public headercheckDisplay: string = "checkbox-hide";
  public headerCheck: string = "unchecked";
  public emptyIndex: any = '-1';
  public successMsg: string = "";

  public offset: number = 0;
  public DisableText: string = 'Disable';
  public limit: number = 20;
  public scrollInit: number = 0;
  public lastScrollTop: number = 0;
  public scrollTop: number;
  public scrollCallback: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number;

  public bodyHeight: number; 
  public innerHeight: number;
  public findLength: number = 0;

  public followingFlag: boolean = false;
  public followerFlag: boolean = false;
  public managerFlag: boolean = false;
  public dashboardFlag: boolean = false;
  public loading2: boolean;
  public fError;
  public fErrorMsg;
  public follow;
  public editIconFlag: boolean;
  public titleFlag: boolean = true;

  public viewTab:boolean = false;
  public contriTab:boolean = false;
  public solvedTab:boolean = false;
  public likeTab:boolean = false;
  public pinTab:boolean = false;
  public metooTab:boolean = false;

  public viewCount:number = 0;
  public contriCount:number = 0;
  public solvedbyCount:number = 0;
  public likeCount:number = 0;
  public pinCount:number = 0;
  public metooCount:number = 0;

  public dashboardUserList:any;
  public dashboardTab:string="";
  public lazyLoading: boolean = false;
  public tvsDomain: boolean = false;

  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  // Resize Widow
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();    
  }

    // Scroll Down
    @HostListener('scroll', ['$event'])
    onScroll(event: any) { console.log(1);
      let inHeight = event.target.offsetHeight + event.target.scrollTop;
      let totalHeight = event.target.scrollHeight - (this.offset * 9);
      this.scrollTop = event.target.scrollTop - 80;
      if (this.scrollTop > this.lastScrollTop && this.scrollInit > 0) { console.log(2);
        console.log(inHeight);
        console.log(totalHeight);
        console.log(this.scrollCallback);
        console.log(this.itemTotal);
        console.log(this.itemLength);
        if (inHeight >= totalHeight && this.scrollCallback && this.itemTotal > this.itemLength) { 
          this.lazyLoading = true;
          this.scrollCallback = false;          
          switch(this.type){     
            case 'thread-dashboard':
              this.getDashboardList(this.dashboardData,'1'); 
              break;
            case 'announcement-dashboard':
            case 'document-dashboard':
              this.getAnnouncementList(this.dashboardData,'1'); 
              break; 
            case 'gts-dashboard':
              this.getGTSList(this.dashboardData); 
              break; 
            case 'ka-dashboard':
              this.getKAList(this.dashboardData); 
              break;
            default:
              this.getFollowingUserList(); 
              break;
          }
        }
      }
      this.lastScrollTop = this.scrollTop;
    }

  constructor(
    private profileService: ProfileService, 
    public activeModal: NgbActiveModal,
    private filterApi: FilterService,
    private formBuilder: UntypedFormBuilder,
    private landingApi: LandingpageService,
    private threadPostService: ThreadPostService,
    private announcementService: AnnouncementService,
    private probingApi: ProductMatrixService,
  ) { }

  ngOnInit(): void {
    this.bodyElem = document.getElementsByTagName('body')[0];
    this.bodyElem.classList.add(this.bodyClass);
    this.bodyElem.classList.add(this.bodyClass1);
    this.searchForm = this.formBuilder.group({
      searchKey: [this.searchVal, [Validators.required]],
    });
    localStorage.removeItem('searchVal');
    this.selectionList = [];

    this.tvsDomain = localStorage.getItem("domainId") == '52' ? true : false;
    
    this.bodyHeight = window.innerHeight;    
    this.setScreenHeight();

    switch(this.type){     
      case 'add-manager':
        this.getMgrList();
        break; 
      case 'thread-dashboard':
        this.dashboardTab = this.dashboardData.dashboardTab;
        this.getDashboardList(this.dashboardData); 
        break;
      case 'announcement-dashboard':
      case 'document-dashboard':
        this.dashboardTab = this.dashboardData.dashboardTab;
        this.getAnnouncementList(this.dashboardData); 
        break; 
      case 'gts-dashboard':
        this.dashboardTab = this.dashboardData.dashboardTab;
        this.getGTSList(this.dashboardData); 
        break; 
      case 'ka-dashboard':
        this.dashboardTab = this.dashboardData.dashboardTab;
        this.getKAList(this.dashboardData); 
        break;
      default:
        this.editIconFlag = (parseInt(this.loginUserId) == parseInt(this.userId)) ? true : false;
        this.getFollowingUserList(); 
        break;
    }
   
  }

  // Set Screen Height
  setScreenHeight() {    
    this.innerHeight = (this.bodyHeight - 170 );  
  }

  getDashboardList(data,scrollFlag=''){
    if(this.tvsDomain){
      this.getDashboardListNew(data,scrollFlag);
    }
    else{
      this.getDashboardListOld(data);
    }
  }

  // Get manager Data
  getDashboardListOld(data) {   
    let industryType:any = localStorage.getItem('industryType');
    let title = (industryType == 3 && data.domainId == 97) ? ManageTitle.feedback : ManageTitle.thread;
    let platformId=localStorage.getItem('platformId');
    title = (platformId=='3') ? ManageTitle.supportRequest : title;
    title = (data.domainId == 411) ? ManageTitle.case : title;
   
    if((data.domainId==71 || data.domainId==515) && platformId=='1')
    {
      title=ManageTitle.supportServices
    }
    if( data.domainId==Constant.CollabticBoydDomainValue && platformId=='1')
    {
      title=ManageTitle.techHelp;
    }

    this.titleFlag = true;
    this.title = `${title} Dashboard`;
   
    const apiFormData = new FormData();
    apiFormData.append('apiKey', data.apiKey);     
    apiFormData.append('domainId', data.domainId);   
    apiFormData.append('countryId', data.countryId); 
    apiFormData.append('userId', data.userId);  
    apiFormData.append('threadId', data.threadId);  
    apiFormData.append('postId', data.postId); 
    apiFormData.append('ismain', data.ismain); 

    this.threadPostService.dashboardUsersListAPI(apiFormData).subscribe(response => {
        console.log(response); 
        this.dashboardUserList = response;

        if(data.ismain == '1' ){
          this.viewCount = this.dashboardUserList.data.views != '' ? this.dashboardUserList.data.views.length : 0;
          this.contriCount = this.dashboardUserList.data.contributers !='' ? this.dashboardUserList.data.contributers.length : 0;
          this.solvedbyCount = this.dashboardUserList.data.solvedby !='' ? this.dashboardUserList.data.solvedby.length : 0;
          this.likeCount = this.dashboardUserList.data.likes != '' ? this.dashboardUserList.data.likes.length : 0
          this.pinCount = this.dashboardUserList.data.pins != '' ? this.dashboardUserList.data.pins.length : 0
          this.metooCount = 0;
        }
        else{
          this.likeCount = this.dashboardUserList.data.likes ? this.dashboardUserList.data.likes.length : 0;
          this.likeTab = true;
        }

        if(this.likeCount > 0 || this.viewCount > 0 || this.contriCount > 0 || this.solvedbyCount > 0 || this.pinCount > 0 || this.metooCount > 0 ) {
          if(data.ismain == '1' ){
             this.dashboardListView(this.dashboardTab,''); 
          }
          else{
            this.dashboardListView('like',''); 
            this.dashboardTab = 'like';
          }
          //this.empty = false;  
        } else {
          this.loading = false; 
          this.dashboardFlag = true; 
          this.empty = true;     
          this.successMsg = "Nothing to show";
        } 

              
    });

  }

  
  // Get manager Data
  getDashboardListNew(data,scrollFlag) {   
    let industryType:any = localStorage.getItem('industryType');
    let title = (industryType == 3 && data.domainId == 97) ? ManageTitle.feedback : ManageTitle.thread;
    let platformId=localStorage.getItem('platformId');
    title = (platformId=='3') ? ManageTitle.supportRequest : title;
    title = (data.domainId == 411) ? ManageTitle.case : title;
   
    if((data.domainId==71 || data.domainId==515) && platformId=='1')
    {
      title=ManageTitle.supportServices
    }
    if( data.domainId==Constant.CollabticBoydDomainValue && platformId=='1')
    {
      title=ManageTitle.techHelp;
    }

    this.titleFlag = true;
    this.title = `${title} Dashboard`;
   
    const apiFormData = new FormData();
    apiFormData.append('apiKey', data.apiKey);     
    apiFormData.append('domainId', data.domainId);   
    apiFormData.append('countryId', data.countryId); 
    apiFormData.append('userId', data.userId);  
    apiFormData.append('threadId', data.threadId);  
    apiFormData.append('postId', data.postId); 
    apiFormData.append('ismain', data.ismain); 
    apiFormData.append("limit", this.limit.toString());
    apiFormData.append("offset", this.offset.toString());

    this.threadPostService.dashboardUsersListAPI(apiFormData).subscribe(response => {
        console.log(response); 
        this.dashboardUserList = response;

        let vList = [];
          let lList = [];
          let pList = [];
          let cList = [];
          let sList = [];

        if(data.ismain == '1' ){

          this.viewCount = this.dashboardUserList.data.viewsCount;         
          this.likeCount = this.dashboardUserList.data.likesCount;      
          this.pinCount = this.dashboardUserList.data.pinsCount;     
          this.contriCount = this.dashboardUserList.data.contributersCount;     
          this.solvedbyCount = this.dashboardUserList.data.solvedbyCount;  
          this.metooCount = 0;            

        vList = this.viewCount > 0 ? this.dashboardUserList.data.views : [];
        if(vList.length>0){
          vList.forEach(item => {
            if(this.viewList.length>0){
              let threadIndex = this.viewList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.viewList.push(item); }
            }
            else{ this.viewList.push(item); }        
          });
        }
                       

        lList = this.likeCount > 0 ? this.dashboardUserList.data.likes : [];
        if(lList.length>0){
          lList.forEach(item => {
            if(this.likeList.length>0){
              let threadIndex = this.likeList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.likeList.push(item); }
            }
            else{ this.likeList.push(item); }        
          });
        }

        pList = this.pinCount > 0 ? this.dashboardUserList.data.pins : [];
        if(pList.length>0){
          pList.forEach(item => {
            if(this.pinList.length>0){
              let threadIndex = this.pinList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.pinList.push(item); }
            }
            else{ this.pinList.push(item); }        
          });
        }

        cList = this.contriCount > 0 ? this.dashboardUserList.data.contributers : [];
        if(cList.length>0){
          cList.forEach(item => {
            if(this.contributoList.length>0){
              let threadIndex = this.contributoList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.contributoList.push(item); }
            }
            else{ this.contributoList.push(item); }        
          });
        }

        sList = this.solvedbyCount > 0 ? this.dashboardUserList.data.solvedby : [];
        if(sList.length>0){
          sList.forEach(item => {
            if(this.solvedByList.length>0){
              let threadIndex = this.solvedByList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.solvedByList.push(item); }
            }
            else{ this.solvedByList.push(item); }        
          });
        }
        }
        else{
          this.likeCount = this.dashboardUserList.data.likesCount;   
          lList = this.likeCount > 0 ? this.dashboardUserList.data.likes : [];
          if(lList.length>0){
            lList.forEach(item => {
              if(this.likeList.length>0){
                let threadIndex = this.likeList.findIndex(option => option.userid ==  item.userid);
                if(threadIndex>=0){}
                else{ this.likeList.push(item); }
              }
              else{ this.likeList.push(item); }        
            });
          }
        }

        if(this.likeCount > 0 || this.viewCount > 0 || this.contriCount > 0 || this.solvedbyCount > 0 || this.pinCount > 0 || this.metooCount > 0 ) {
          if(data.ismain == '1' ){
             this.dashboardListView(this.dashboardTab,scrollFlag); 
          }
          else{
            this.dashboardListView('like',scrollFlag); 
            this.dashboardTab = 'like';
          }
          //this.empty = false;  
        } else {
          this.loading = false; 
          this.dashboardFlag = true; 
          this.empty = true;     
          this.successMsg = "Nothing to show";
        } 

              
    });

  }

  // Get manager Data
  getAnnouncementList(data,scrollFlag='') {   

    this.titleFlag = true;    
    
    this.title = (this.type == 'announcement-dashboard') ? "Announcement Dashboard" : "Document Dashboard" ;
    
    const apiFormData = new FormData();
    apiFormData.append('apiKey', data.apiKey);     
    apiFormData.append('domainId', data.domainId); 
    apiFormData.append('countryId', data.countryId);     
    apiFormData.append('userId', data.userId);  
    apiFormData.append('dataId', data.threadId);
    apiFormData.append("limit", this.limit.toString());
    apiFormData.append("offset", this.offset.toString());

    this.announcementService.announceDashboard(apiFormData).subscribe(response => {
        console.log(response); 
        this.dashboardUserList = response;      
        
        this.viewCount = this.dashboardUserList.readUsersTotal;         
        this.likeCount = this.dashboardUserList.LikesTotal;   
        this.pinCount = this.dashboardUserList.pinTotal;   
        
        let vList = [];
        let lList = [];
        let pList = [];

        vList = this.viewCount > 0 ? this.dashboardUserList.readUsers : [];
        if(vList.length>0){
          vList.forEach(item => {
            if(this.tvsDomain){
              item.lastUpdateDate = "-";
              console.log(item.updatedOn,item.userName);
              if(item.updatedOn){
                let updatedOn = moment.utc(item.updatedOn).toDate();
                item.lastUpdateDate = moment(updatedOn).local().format('MMM DD, YYYY . h:mm A');
              }
            }
            if(this.viewList.length>0){              
              let threadIndex = this.viewList.findIndex(option => option.loginId ==  item.loginId);
              if(threadIndex>=0){}
              else{ this.viewList.push(item); }
            }
            else{ this.viewList.push(item); }        
          });
        }                       

        lList = this.likeCount > 0 ? this.dashboardUserList.Likes : [];
        if(lList.length>0){
          lList.forEach(item => {  
            if(this.tvsDomain){           
              item.lastUpdateDate = "-";
              if(item.updatedOn){
                let updatedOn = moment.utc(item.updatedOn).toDate();
                item.lastUpdateDate = moment(updatedOn).local().format('MMM DD, YYYY . h:mm A');
              }   
            }         
            if(this.likeList.length>0){
              let threadIndex = this.likeList.findIndex(option => option.loginId ==  item.loginId);
              if(threadIndex>=0){}
              else{ this.likeList.push(item); }
            }
            else{ this.likeList.push(item); }        
          });
        }

        pList = this.pinCount > 0 ? this.dashboardUserList.pins : [];
        if(pList?.length>0){
          pList?.forEach(item => {
            if(this.tvsDomain){
              item.lastUpdateDate = "-";
              if(item.updatedOn){
                let updatedOn = moment.utc(item.updatedOn).toDate();
                item.lastUpdateDate = moment(updatedOn).local().format('MMM DD, YYYY . h:mm A');
              }
            }
            if(this.pinList?.length>0){
              let threadIndex = this.pinList?.findIndex(option => option.loginId ==  item.loginId);
              if(threadIndex>=0){}
              else{ this.pinList?.push(item); }
            }
            else{ this.pinList?.push(item); }        
          });
        }

        if(this.likeCount > 0 || this.viewCount > 0 || this.pinCount > 0 ) {          
              this.annDashboardListView(this.dashboardTab,'1');           
        } else {
          this.loading = false; 
          this.dashboardFlag = true; 
          this.empty = true;     
          this.successMsg = "Nothing to show";
        } 

              
    });

  }

  // Get manager Data
  getGTSList(data,scrollFlag='') {   

    this.titleFlag = true;    
    
    this.title = "GTS Dashboard" ;
    
    const apiFormData = new FormData();
    apiFormData.append('apiKey', data.apiKey);     
    apiFormData.append('domainId', data.domainId); 
    apiFormData.append('countryId', data.countryId);     
    apiFormData.append('userId', data.userId);  
    apiFormData.append('dataId', data.threadId);

    this.announcementService.announceDashboard(apiFormData).subscribe(response => {
        console.log(response); 
        this.dashboardUserList = response;      
        
        this.viewCount = this.dashboardUserList.readUsersTotal;          
        this.likeCount = this.dashboardUserList.LikesTotal;   
        this.pinCount = this.dashboardUserList.pinTotal;   


        let vList = [];
        let lList = [];
        let pList = [];

        vList = this.viewCount > 0 ? this.dashboardUserList.readUsers : [];
        if(vList.length>0){
          vList.forEach(item => {
            if(this.viewList.length>0){
              let threadIndex = this.viewList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.viewList.push(item); }
            }
            else{ this.viewList.push(item); }        
          });
        }
                       

        lList = this.likeCount > 0 ? this.dashboardUserList.Likes : [];
        if(lList.length>0){
          lList.forEach(item => {
            if(this.likeList.length>0){
              let threadIndex = this.likeList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.likeList.push(item); }
            }
            else{ this.likeList.push(item); }        
          });
        }

        pList = this.pinCount > 0 ? this.dashboardUserList.pins : [];
        if(pList.length>0){
          pList.forEach(item => {
            if(this.pinList.length>0){
              let threadIndex = this.pinList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.pinList.push(item); }
            }
            else{ this.pinList.push(item); }        
          });
        }

        if(this.likeCount > 0 || this.viewCount > 0 || this.pinCount > 0 ) {          
              this.annDashboardListView(this.dashboardTab,'1');           
        } else {
          this.loading = false; 
          this.dashboardFlag = true; 
          this.empty = true;     
          this.successMsg = "Nothing to show";
        } 

              
    });
  
  }

  // Get manager Data
  getKAList(data,scrollFlag='') {   

    this.titleFlag = true;    
    
    this.title = "Knowledge Article Dashboard" ;
    
    const apiFormData = new FormData();
    apiFormData.append('apiKey', data.apiKey);     
    apiFormData.append('domainId', data.domainId); 
    apiFormData.append('countryId', data.countryId);     
    apiFormData.append('userId', data.userId);  
    apiFormData.append('dataId', data.threadId);

    this.announcementService.kaDashboard(apiFormData).subscribe(response => {
        console.log(response); 
        this.dashboardUserList = response;      
        
        this.viewCount = this.dashboardUserList.readUsersTotal;          
        this.likeCount = this.dashboardUserList.LikesTotal;   
        this.pinCount = this.dashboardUserList.pinTotal;   


        let vList = [];
        let lList = [];
        let pList = [];

        vList = this.viewCount > 0 ? this.dashboardUserList.readUsers : [];
        if(vList.length>0){
          vList.forEach(item => {
            if(this.viewList.length>0){
              let threadIndex = this.viewList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.viewList.push(item); }
            }
            else{ this.viewList.push(item); }        
          });
        }
                       

        lList = this.likeCount > 0 ? this.dashboardUserList.Likes : [];
        if(lList.length>0){
          lList.forEach(item => {
            if(this.likeList.length>0){
              let threadIndex = this.likeList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.likeList.push(item); }
            }
            else{ this.likeList.push(item); }        
          });
        }

        pList = this.pinCount > 0 ? this.dashboardUserList.pins : [];
        if(pList.length>0){
          pList.forEach(item => {
            if(this.pinList.length>0){
              let threadIndex = this.pinList.findIndex(option => option.userid ==  item.userid);
              if(threadIndex>=0){}
              else{ this.pinList.push(item); }
            }
            else{ this.pinList.push(item); }        
          });
        }

        if(this.likeCount > 0 || this.viewCount > 0 || this.pinCount > 0 ) {          
              this.annDashboardListView(this.dashboardTab,'1');           
        } else {
          this.loading = false; 
          this.dashboardFlag = true; 
          this.empty = true;     
          this.successMsg = "Nothing to show";
        }  

              
    });
  
  }
    
  dashboardListView(tab,scrollFlag){
    if(this.tvsDomain){
      this.dashboardListViewNew(tab,scrollFlag);
    }
    else{
      this.dashboardListViewOld(tab);
    }
  }
  

  dashboardListViewOld(tab){ 
    
    this.viewTab = false;
    this.contriTab = false;
    this.solvedTab = false;
    this.likeTab = false;
    this.pinTab = false;
    this.metooTab = false;
    this.dashboardTab = tab;    
    switch(tab){
      case 'views':                    
        this.manageList = this.viewCount > 0 ? this.dashboardUserList.data.views : [];
        this.viewTab = true;  
        break; 
      case 'contributors':
        this.manageList = this.contriCount > 0 ? this.dashboardUserList.data.contributers : []; 
        this.contriTab = true;
        break;
      case 'solvedby':
        this.manageList = this.solvedbyCount > 0 ? this.dashboardUserList.data.solvedby : []; 
        this.solvedTab = true;
        break;
      case 'like':
        this.manageList = this.likeCount > 0 ? this.dashboardUserList.data.likes: [];
        this.likeTab = true;
        break;
      case 'pin':
        this.manageList = this.pinCount > 0 ? this.dashboardUserList.data.pins: []; 
        this.pinTab = true;
        break;
      case 'metoo':
        this.manageList = [];
        this.metooTab = true;
        break;
      default:
        this.manageList = this.viewCount > 0 ? this.dashboardUserList.data.views : [];
        this.viewTab = true; 
        break;
    } 

    this.loading = false; 
    this.dashboardFlag = true; 
    
    console.log(this.manageList);
    this.manageList = this.manageList;
    this.listLength = this.manageList == '' ? 0 : this.manageList.length; 
        
    this.listItems = [];
    this.listItems = this.manageList;

    for(let t in this.listItems) {  
      this.listItems[t].displayFlag = true;  
    }         
    
    
    if(this.listLength == 0) { console.log(this.listLength);
      this.empty = true;      
      this.successMsg = "Nothing to show";
    } else {     
      this.empty = false; 
    } 
  }

  dashboardListViewNew(tab,scrollFlag){ 
    
    this.viewTab = false;
    this.contriTab = false;
    this.solvedTab = false;
    this.likeTab = false;
    this.pinTab = false;
    this.metooTab = false;
    this.dashboardTab = tab;    
    switch(tab){
      case 'views':                    
        this.manageList = this.viewList;
        this.viewTab = true; 
        this.itemTotal = this.viewCount;   
        break; 
      case 'contributors':
        this.manageList = this.contributoList; 
        this.contriTab = true;
        this.itemTotal = this.contriCount; 
        break;
      case 'solvedby':
        this.manageList = this.solvedByList;
        this.solvedTab = true;
        this.itemTotal = this.solvedbyCount;
        break;
      case 'like':
        this.manageList = this.likeList;
        this.likeTab = true;
        this.itemTotal = this.likeCount;
        break;
      case 'pin':
        this.manageList = this.pinList; 
        this.pinTab = true;
        this.itemTotal = this.pinCount;
        break;
      case 'metoo':
        this.manageList = [];
        this.metooTab = true;
        this.itemTotal = 0;
        break;
      default:
        this.manageList = this.viewList;
        this.viewTab = true; 
        this.itemTotal = this.viewCount;
        break;
    } 

    this.loading = false; 
    this.lazyLoading = false;
    this.dashboardFlag = true;      
        
    this.listItems = [];
    this.listItems = this.manageList;

    for(let t in this.listItems) {  
      this.listItems[t].displayFlag = true;  
    }  
    
    console.log(this.manageList);
    console.log(this.listItems);
        
    let itemListLen = this.manageList.length;
    this.listLength = this.manageList.length;

    if(this.listLength == 0) { 
      this.empty = true;      
      this.successMsg = "Nothing to show";
    } else {     
      this.empty = false; 
      this.scrollCallback = true;
      this.scrollInit = 1;
      this.itemLength = itemListLen;    
      if(scrollFlag == '1'){
        this.offset += this.limit;
      }
    } 

  }

  annDashboardListView(tab,scrollFlag){ 

    this.viewTab = false;   
    this.likeTab = false;   
    this.pinTab = false;   
    this.dashboardTab = tab;   
    
    switch(tab){
      case 'views':        
        this.manageList = this.viewList;
        this.viewTab = true; 
        this.itemTotal = this.viewCount; 
        break;       
      case 'like':
        this.manageList = this.likeList;
        this.likeTab = true;
        this.itemTotal = this.likeCount; 
        break;  
      case 'pin':
        this.manageList = this.pinList;
        this.pinTab = true;
        this.itemTotal = this.pinCount;
        break; 
      default:
        this.manageList = this.viewList;
        this.viewTab = true; 
        this.itemTotal = this.viewCount; 
        break;
    }

    this.loading = false; 
    this.lazyLoading = false;
    this.dashboardFlag = true;      
        
    this.listItems = [];
    this.listItems = this.manageList;

    for(let t in this.listItems) {  
      this.listItems[t].profile = this.listItems[t].profileImg;
      this.listItems[t].username = this.listItems[t].userName;
      this.listItems[t].userid = this.listItems[t].loginId;
      this.listItems[t].displayFlag = true;  
    }  
    
    console.log(this.manageList);
    console.log(this.listItems);
        
    let itemListLen = this.manageList.length;
    this.listLength = this.manageList.length;

    if(this.listLength == 0) { 
      this.empty = true;      
      this.successMsg = "Nothing to show";
    } else {     
      this.empty = false; 
      this.scrollCallback = true;
      this.scrollInit = 1;
      this.itemLength = itemListLen;    
      if(scrollFlag == '1'){
        this.offset += this.limit;
      }
    } 
  }

  // Get Filter Data
  getFollowingUserList() {

    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiKey);     
    apiFormData.append('userId', this.userId);   

    this.profileService.getuserFollowerFollowing(apiFormData).subscribe(response => {
     
      this.loading = false;  

      if(this.type == 'following'){      
        this.manageList = response.response.following;
        this.listLength = this.manageList.length;
        this.count = this.listLength;
        this.title = "Following";
        this.followingFlag = true;
        this.titleFlag = false;
      }
      else{  
        this.manageList = response.response.followers;
        this.listLength = this.manageList.length;
        this.count = this.listLength;
        this.title = ( this.listLength > 1 ) ? 'Followers' : 'Follower';
        this.followerFlag = true;
        this.titleFlag = false;
      }
    
      this.listItems = [];
      this.listItems = this.manageList;

      for(let t in this.listItems) {  
        this.listItems[t].displayFlag = true;  
      }         
     
      if(this.listLength > 0) {
        this.empty = false;        
      } else {
        this.empty = true;
        this.successMsg = "Nothing to show";
      }

    });
  }

   // Get manager Data
   getMgrList() {    
 
    this.managerFlag = true; 
    this.titleFlag = true;

    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiKey);     
    apiFormData.append('userId', this.loginUserId);   
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('type', '1');

    this.landingApi.getManagerList(apiFormData).subscribe((response) => {

      this.loading = false;         
      this.manageList = response.managerList;
      this.listLength = response.data;
      this.title = "Select Manager";
      
      this.listItems = [];
      this.listItems = this.manageList;

      for(let t in this.listItems) {  
        this.listItems[t].displayFlag = true;  
      }         
     
      if(this.listLength > 0) {
        this.empty = false;        
      } else {
        this.empty = true;
        this.successMsg = "Nothing to show";
      }

    });
  }


  // On Submit
  onSubmit() {
    this.submitted = true;
    if (this.searchForm.invalid) {  
      return;
    } else {
      this.searchVal = this.searchForm.value.searchKey;
      this.submitSearch();
    }
  }

  // Search Onchange
  onSearchChange(searchValue : string ) {  
    this.searchForm.value.searchKey = searchValue;
    this.searchTick = (searchValue.length > 0) ? true : false;
    this.searchClose = this.searchTick;
    this.searchVal = searchValue;
    if(searchValue.length == 0) {
      this.submitted = false;
    }

    let filteredList = this.manageList.filter(option => option.userName.toLowerCase().indexOf(this.searchVal.toLowerCase()) !== -1);
    if(filteredList.length > 0) {
      this.empty = false;
      for(let t in this.listItems) {
        this.listItems[t].displayFlag = false;
        for(let f in filteredList) {
          if(this.listItems[t].userName == filteredList[f].userName) {
            this.listItems[t].displayFlag = true;
          }
        }
      }
    } else {
      this.empty = true;
      this.successMsg = "Nothing to show";
    }               
  }

  // Submit Search
  submitSearch() {
        
  }

  // Clear Search
  clearSearch() {
    this.searchVal = '';
    this.searchTick = false;
    this.searchClose = this.searchTick;
    this.submitted = this.searchTick;
    this.empty = this.searchTick;
    for(let m in this.listItems) {
      this.listItems[m].displayFlag = true;     
    }
  }

  // Close
  close() {
    this.searchVal = '';
    this.bodyElem.classList.remove(this.bodyClass);    
    this.bodyElem.classList.remove(this.bodyClass1);    
    if(this.type=='add-manager'){
      let data = {
        empty: true,
        init: false
      };
      this.updatefollowingResponce.emit(data); 
    }
    else{     
      this.count = this.count > 0 ? this.count : 0;
      let value = this.count > 0 ? this.count : 'novalue' ;
      this.updatefollowingResponce.emit(value); 
    }
    
  }

  followORUnfollow(type,userId){ 

    this.fErrorMsg = '';  
    this.fError = false; 
   
    document.getElementById("unfollow-"+userId).classList.add('setOpacity3');
    document.getElementById("follow-"+userId).classList.add('setOpacity3');

    const apiFormData = new FormData();
    if(this.type == 'thread-dashboard' || 'ka-dashboard' || this.type == 'announcement-dashboard' || this.type == 'thread-dashboard'){      
      apiFormData.append('apiKey', this.dashboardData.apiKey);
      apiFormData.append('domainId', this.dashboardData.domainId);
      apiFormData.append('countryId', this.dashboardData.countryId);
      apiFormData.append('userId', userId);
      apiFormData.append('loginId', this.dashboardData.userId);
      apiFormData.append('action', type);
    }
    else{      
      apiFormData.append('apiKey', this.apiKey);
      apiFormData.append('domainId', this.domainId);
      apiFormData.append('countryId', this.dashboardData.countryId);
      apiFormData.append('userId', userId);
      apiFormData.append('loginId', this.loginUserId);
      apiFormData.append('action', type);
    }
 
    this.profileService.userFollowMethod(apiFormData).subscribe(res => {

      if(res.status=='Success'){
        
        if(this.type == 'thread-dashboard'){    
          this.getDashboardList(this.dashboardData);
        }
        else if(this.type == 'ka-dashboard'){    
          this.getKAList(this.dashboardData);
        }
        else{
          
        
      
        
        document.getElementById("unfollow-"+userId).classList.remove('setOpacity3');
        document.getElementById("follow-"+userId).classList.remove('setOpacity3');
  
        if(type == 'follow'){
          this.count = this.count + 1;

          document.getElementById("follow-"+userId).classList.remove('showButton');
          document.getElementById("follow-"+userId).classList.add('hideButton');
          document.getElementById("unfollow-"+userId).classList.remove('hideButton');
          document.getElementById("unfollow-"+userId).classList.add('showButton');

        }
        else{
          this.count = this.count - 1;
          this.count = this.count > 0 ? this.count : 0;
          
          document.getElementById("follow-"+userId).classList.add('showButton');
          document.getElementById("follow-"+userId).classList.remove('hideButton');
          document.getElementById("unfollow-"+userId).classList.add('hideButton');
          document.getElementById("unfollow-"+userId).classList.remove('showButton');
        }     
      }
         
      }
      else{   
        document.getElementById("unfollow-"+userId).classList.remove('setOpacity3');
        document.getElementById("follow-"+userId).classList.remove('setOpacity3');
        this.fErrorMsg = res.result;  
        this.fError = true;   
      }
                
    },
    (error => {
      document.getElementById("unfollow-"+userId).classList.remove('setOpacity3');
      document.getElementById("follow-"+userId).classList.remove('setOpacity3');

      this.fErrorMsg = error;
      this.fError = true;        
    })
    );


    
  }

  // Item Selection
  itemSelection( uid, name) {
    let data = {
      mId: uid,
      mName: name
    };
    this.updatefollowingResponce.emit(data); 
    console.log(name); 
  }

  tapfrompopup(id)
  {

  var aurl=forumPageAccess.profilePage+id;
 
  window.open(aurl, '_blank');

  }
  
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    console.log(event);
    this.close();
  }


  hideallToooltips(){
    let elem3: any= '';
    elem3 = document.getElementsByTagName('ngb-tooltip-window');
    if(elem3 && elem3.length>0 ){
      console.log(1)
      elem3[0].classList.remove("show");
    }
  }
  getUserProfileStatus(uid,index) {
    let elem: any= '';
    let elem1: any= '';
    let ariadescribedby: any ='';
    elem = document.getElementById('ngbTooltip'+index);
    if(elem){
      ariadescribedby = elem.getAttribute("aria-describedby");
      elem1 = document.getElementById(ariadescribedby);
      if(elem1){
        if(!elem1.classList.contains("show")){
          console.log(2)
          !elem1.classList.add("show");
        };
      }
    }
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    let domainId = localStorage.getItem("domainId");
    apiFormData.append('domainId', domainId);
    apiFormData.append('userId', uid);
    this.probingApi.GetUserAvailability(apiFormData).subscribe((response) => {
      let resultData = response.items;
      let availability = resultData.availability;
      let availabilityStatusName = resultData.availabilityStatusName;
      let badgeTopUser = resultData.badgeTopUser;
      this.listItems[index].availability = availability;
      this.listItems[index].availabilityStatusName = availabilityStatusName;
      this.listItems[index].profileShow = true;
    });
  }
    // tab on user profile page
    taponprofileclick(userId){
      var aurl='profile/'+userId+'';
      window.open(aurl, aurl);
    }
	

}

